import { render } from "./FormTime.vue?vue&type=template&id=2ebdbb5e"
import script from "./FormTime.vue?vue&type=script&lang=js"
export * from "./FormTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__